module.exports = __webpack_public_path__ + "img/capacitor-yellow.71f6ff73.webp";